import { Button as e } from "./Button.mjs";
import { Tooltip as t } from "../Tooltip/Tooltip.mjs";
import n from "react";
import { styled as r } from "styled-components";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/Button/IconButton.tsx
var a = r(e)`
    border-radius: 50% !important;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: ${({ theme: e }) => e.spacing(1, .5)};

    /* Prevent the icon SVG from swallowing click events */
    & > * {
        pointer-events: none;
    }
`, o = n.forwardRef(({ icon: e, label: n, tooltip: r, tooltipSide: o = "top", size: s = "icon", variant: c = "ghost", ...l }, u) => {
	let d = /* @__PURE__ */ i(a, {
		ref: u,
		size: s,
		variant: c,
		"aria-label": n || (typeof r == "string" ? r : void 0),
		...l,
		children: e
	});
	return r ? /* @__PURE__ */ i(t, {
		content: r,
		side: o,
		children: d
	}) : d;
});
o.displayName = "IconButton";
//#endregion
export { o as IconButton };
